import {LuSparkle} from "react-icons/lu";
import {Link, LinkProps} from "react-router";

import {Button} from "@/components/button/Button.tsx";
import {ButtonSize} from "@/components/button/Button.types.ts";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {ANALYZER} from "@/lib/featureFlags.ts";
import {AnalyzerSource} from "@/lib/queries/analyzerRuns.ts";

interface CreateWithAssistantButtonProps extends Omit<LinkProps, "to" | "children"> {
  size?: ButtonSize;
  source: AnalyzerSource;
}

export const CreateWithAssistantButton = ({size, source, state, ...linkProps}: CreateWithAssistantButtonProps) => {
  const {user, userHasFeature} = useCurrentUserContext();

  if (!user?.has_write_access || !userHasFeature(ANALYZER)) {
    return null;
  }

  return (
    <Button
      as={Link}
      to="/assistant/checks/create"
      state={{...state, source}}
      variant="secondary"
      size={size}
      {...linkProps}
    >
      <Icon icon={LuSparkle} className="text-success" />
      <span>Create with Assistant</span>
    </Button>
  );
};
